import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MPassService } from '../../services/mpass.service';
import { DragHandleComponent } from 'src/app/shared/drag-handle/drag-handle.component';

@Component({
  selector: 'app-login-payment-iframe',
  standalone: true,
  imports: [DragHandleComponent],
  templateUrl: './login-payment-iframe.component.html',
  styleUrls: ['./login-payment-iframe.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class LoginPaymentIframeComponent {
    private _sanitizer = inject(DomSanitizer);
    private _mpassService = inject(MPassService);

    private hashUrl = computed(() => this._mpassService.hashUrl());
    public urlIframe: SafeResourceUrl;

    ngOnInit(){
      const url = `https://mpass.mobi/p360/?token=${this.hashUrl()}&appDestination=marketplace#/marketplace`;
      this.urlIframe = this._sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
